import React from "react";
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from "recharts";
import { parseISO, format } from "date-fns";
import Title from "./Title";

const MessagesTrafficChart = ({ data }) => {
  // Parse data into date-grouped sent and received metrics
  const processData = () => {
    if (!data || !Array.isArray(data)) return [];

    const map = new Map();
    data.forEach((item) => {
      const dateStr = format(parseISO(item.date), "dd/MM");
      if (!map.has(dateStr)) {
        map.set(dateStr, { date: dateStr, sent: 0, received: 0 });
      }
      const entry = map.get(dateStr);
      const count = parseInt(item.count) || 0;
      if (item.fromMe) {
        entry.sent += count;
      } else {
        entry.received += count;
      }
    });

    return Array.from(map.values()).sort((a, b) => {
      const [dayA, monthA] = a.date.split("/");
      const [dayB, monthB] = b.date.split("/");
      return new Date(2026, monthA - 1, dayA) - new Date(2026, monthB - 1, dayB);
    });
  };

  const chartData = processData();

  return (
    <div className="w-full h-full flex flex-col">
      <Title>Volumen de Tráfico de Mensajes</Title>
      <div className="w-full h-64 relative">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={chartData} margin={{ top: 10, right: 10, left: -20, bottom: 0 }}>
            <defs>
              <linearGradient id="colorSent" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#10b981" stopOpacity={0.4} />
                <stop offset="95%" stopColor="#10b981" stopOpacity={0} />
              </linearGradient>
              <linearGradient id="colorReceived" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#6366f1" stopOpacity={0.4} />
                <stop offset="95%" stopColor="#6366f1" stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" className="dark:stroke-slate-800" />
            <XAxis dataKey="date" stroke="#94a3b8" tick={{ fontSize: 11 }} />
            <YAxis stroke="#94a3b8" tick={{ fontSize: 11 }} allowDecimals={false} />
            <Tooltip
              contentStyle={{
                backgroundColor: "rgba(255, 255, 255, 0.95)",
                border: "1px solid #e2e8f0",
                borderRadius: "12px",
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
                fontSize: "12px",
                color: "#1e293b",
              }}
              labelStyle={{ fontWeight: "bold", marginBottom: "4px" }}
            />
            <Legend verticalAlign="top" height={36} iconType="circle" iconSize={8} wrapperStyle={{ fontSize: "12px" }} />
            <Area
              type="monotone"
              dataKey="received"
              stroke="#6366f1"
              strokeWidth={2}
              fillOpacity={1}
              fill="url(#colorReceived)"
              name="Mensajes Recibidos"
            />
            <Area
              type="monotone"
              dataKey="sent"
              stroke="#10b981"
              strokeWidth={2}
              fillOpacity={1}
              fill="url(#colorSent)"
              name="Mensajes Enviados"
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default MessagesTrafficChart;
